import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'paidSearch',
})
export class PaidSearchPipe implements PipeTransform {
  transform(items: any, keyword: string, selectType: string, month): unknown {
    let result = items;

    if (keyword) {
      result = items?.filter(ele => {
        return ele.shopId?.owner.indexOf(keyword) > -1 || ele.shopId.shopName?.indexOf(keyword) > -1;
      });
    } else {
      result = result;
    }

    if (selectType !== 'all') {
      result = result?.filter(ele => {
        return selectType === 'yet' ? !ele.paidDate : ele.paidDate;
      });
    } else {
      result = result;
    }

    if (month) {
      result = result?.filter(ele => {
        return moment(ele.paidMonth).format('YYYY-MM') === month;
      });
    } else {
      result = result;
    }

    return result;
  }
}
